<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="vertical">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="所属管线" prop="pipelineId">
                <a-select
                  v-model="queryParam.pipelineId"
                  placeholder="请选择所属管线"
                  allow-clear
                  show-search
                  :filter-option="filterOption"
                >
                  <a-select-option v-for="item in pipelineList" :key="item.id" :value="item.id">
                    {{ item.pipelineName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="选择时间" prop="deviceId">
                <a-date-picker v-model="queryParam.queryTime" format="YYYY-MM-DD"> </a-date-picker>
              </a-form-item>
            </a-col>
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <!-- <a-button
                  style="margin-left: 8px"
                  @click="resetQuery"
                ><a-icon type="redo" />重置</a-button> -->
                <!-- <a
                  @click="toggleAdvanced"
                  style="margin-left: 8px"
                >
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a> -->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div>
        <div class="pubLoading" v-show="showLoading">
          <a-icon slot="indicator" type="loading" style="font-size: 80px" spin />
        </div>
        <lineChart8 :chartData="chartData" v-if="isShow && !showLoading" @chanegDetail="chanegDetail"></lineChart8>
        <div v-if="isShow">
          <!-- <div class="ping">评价列表</div> -->
          <!-- 数据展示 -->
          <!-- <a-table
            :loading="loading"
            :size="tableSize"
            rowKey="id"
            :columns="columns"
            :data-source="list"
            :pagination="false"
            :bordered="tableBordered"
          >
          </a-table> -->
          <!-- 分页 -->
          <!-- <a-pagination
            class="ant-table-pagination"
            show-size-changer
            show-quick-jumper
            :current="queryParam.pageNum"
            :total="total"
            :page-size="queryParam.pageSize"
            :showTotal="total => `共 ${total} 条`"
            @showSizeChange="onShowSizeChange"
            @change="changeSize"
          /> -->
        </div>
        <div class="kong" v-show="!isShow && !showLoading">
          <img src="~@/assets/images/kong.png" alt="" />
          <div>暂无数据</div>
        </div>
      </div>
    </a-card>
    <create-form ref="createForm" />
  </page-header-wrapper>
</template>

<script>
import { tableMixin } from '@/store/table-mixin'
import { listPipeline, protectionChart } from '@/api/saifuneng/devicedata'
import lineChart8 from '../../../Charts/lineChart8.vue'
import CreateForm from './CreateForm.vue'
import moment from 'moment'
export default {
  name: 'Setup',
  components: {
    lineChart8,
    CreateForm
  },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  data() {
    return {
      pipelineList: [],
      showLoading: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      isShow: false,
      total: 0,
      // 日期范围
      dateRange: [],
      chartData: {},
      list: [],
      columns: [
        {
          title: '位置信息',
          dataIndex: 'index',
          ellipsis: true,
          width: 200,
          align: 'center'
        },
        {
          title: '通电信息',
          dataIndex: 'locationDescription',
          ellipsis: true,
          width: 200,
          align: 'center'
        },
        {
          title: '断电电位',
          dataIndex: 'locationDescription1',
          ellipsis: true,
          width: 200,
          align: 'center'
        },
        {
          title: '判断数据',
          dataIndex: 'locationDescription12',
          ellipsis: true,
          width: 200,
          align: 'center'
        },
        {
          title: '建议措施',
          dataIndex: 'locationDescription123',
          ellipsis: true,
          width: 200,
          align: 'center'
        }
      ],
      list: [],
      // 查询参数
      queryParam: {
        pipelineId: null,
        queryTime: null
      }
    }
  },
  filters: {},
  created() {
    this.getPipelineList()
  },
  computed: {},
  watch: {},
  methods: {
    // 查询所属管线
    getPipelineList() {
      listPipeline().then((response) => {
        this.pipelineList = response.data
      })
    },
    // 点击查看详情
    chanegDetail(e) {
      let deviceId = this.list[e.dataIndex].deviceId
      this.$store.dispatch('getDeviceConfigInfo', { deviceId })
      let time = moment(this.queryParam.queryTime).format('YYYY-MM-DD')
      this.$nextTick(() => {
        this.$refs.createForm.handleUpdate(deviceId, time, time)
      })
    },
    getList() {
      protectionChart(this.queryParam).then((res) => {
        res = res.data
        let chartData = {
          electrifiedPotentialAverage: [],
          electrifiedPotentialMax: [],
          electrifiedPotentialMin: [],
          locationDescription: [],
          voffAverage: [],
          voffMax: [],
          voffMin: []
        }
        this.list = res.dataList
        if (res.dataList.length) {
          res.dataList.forEach((v) => {
            chartData.electrifiedPotentialAverage.push(
              v.electrifiedPotentialAverage ? v.electrifiedPotentialAverage.toFixed(3) : null
            )
            chartData.electrifiedPotentialMax.push(
              v.electrifiedPotentialMax ? v.electrifiedPotentialMax.toFixed(3) : null
            )
            chartData.electrifiedPotentialMin.push(
              v.electrifiedPotentialMin ? v.electrifiedPotentialMin.toFixed(3) : null
            )
            chartData.locationDescription.push(v.locationDescription ? v.locationDescription : null)
            chartData.voffAverage.push(v.voffAverage ? v.voffAverage.toFixed(3) : null)
            chartData.voffMax.push(v.voffMax ? v.voffMax.toFixed(3) : null)
            chartData.voffMin.push(v.voffMin ? v.voffMin.toFixed(3) : null)
            chartData.limitMax1 = res.limitMax1
            chartData.limitMax2 = res.limitMax2
            chartData.limitMin1 = res.limitMin1
            chartData.limitMin2 = res.limitMin2
            chartData.deviceId = v.deviceId
          })
          this.isShow = true
        } else {
          this.isShow = false
        }
        this.chartData = chartData
        this.showLoading = false
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    handleQuery() {
      if (!this.queryParam.pipelineId) return this.$message.error('请选择所属管线')
      if (!this.queryParam.queryTime) return this.$message.error('请选择时间')
      this.showLoading = true
      this.getList()
    },
    resetQuery() {}
  }
}
</script>
<style lang="less" scoped>
.kong {
  text-align: center;
}

.ping {
  margin-top: 20px;
  text-align: center;
}
</style>
